module.exports = __webpack_public_path__ + "img/arrow.7e3b0cdb.svg";